// extracted by mini-css-extract-plugin
export default {"BracketInfo":"GameSeriesHeader-module__BracketInfo__rjgYS"};